/* FBS GA4 Storefront events.
 * Uses the existing Google tag loaded by the Shopify Google & YouTube app.
 * Never loads gtag.js, never sends page_view, never adds a GA4 config.
 * Set window.FBS_GA4_DEBUG = true to log to the console.
 */
(function () {
  'use strict';

  var SENT = new Set();
  var VIEW_LIST_LIMIT = 24;

  function debug() {
    if (!window.FBS_GA4_DEBUG) return;
    try { console.log.apply(console, ['[FBS GA4]'].concat([].slice.call(arguments))); } catch (_) {}
  }

  function track(eventName, params, dedupeKey) {
    try {
      if (!eventName) return;
      if (dedupeKey && SENT.has(dedupeKey)) {
        debug('dedupe skip', eventName, dedupeKey);
        return;
      }
      if (dedupeKey) SENT.add(dedupeKey);

      var payload = params || {};
      debug('send', eventName, payload, dedupeKey || '');

      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
        return;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ecommerce: payload });
    } catch (err) {
      debug('tracking failed', eventName, err);
    }
  }

  window.fbsTrackGa4Event = track;

  function readJson(node) {
    if (!node) return null;
    try { return JSON.parse(node.textContent || 'null'); } catch (_) { return null; }
  }

  function readCardItem(card) {
    return readJson(card.querySelector('script[type="application/json"][data-fbs-ga4-item]'));
  }

  // view_item_list — read grid-level JSON payloads emitted by Liquid.
  // Server-rendered payloads avoid per-card aggregation timing issues.
  function fireViewItemList() {
    var blocks = document.querySelectorAll('script[type="application/json"][data-fbs-ga4-view-item-list]');
    Array.prototype.forEach.call(blocks, function (block) {
      var payload;
      try { payload = JSON.parse(block.textContent || 'null'); } catch (err) {
        debug('view_item_list parse failed', err);
        return;
      }
      if (!payload || !Array.isArray(payload.items) || payload.items.length === 0) return;
      var listId = payload.item_list_id || block.getAttribute('data-fbs-list-id') || '';
      var listName = payload.item_list_name || block.getAttribute('data-fbs-list-name') || '';
      var dedupeKey = 'view_item_list:' + location.pathname + ':' + location.search + ':' + listId;
      track('view_item_list', {
        item_list_id: listId,
        item_list_name: listName,
        items: payload.items.slice(0, VIEW_LIST_LIMIT)
      }, dedupeKey);
    });
  }

  // select_item — delegated click on a product card inside a tracked list.
  function onSelectItemClick(event) {
    try {
      var card = event.target.closest && event.target.closest('[data-fbs-ga4-card]');
      if (!card) return;
      var item = readCardItem(card);
      if (!item) return;
      var list = card.closest('[data-fbs-ga4-list]');
      var listId = list ? (list.getAttribute('data-fbs-ga4-list-id') || '') : '';
      var listName = list ? (list.getAttribute('data-fbs-ga4-list-name') || '') : '';
      var index = -1;
      if (list) {
        var siblings = Array.prototype.slice.call(list.querySelectorAll('[data-fbs-ga4-card]'));
        index = siblings.indexOf(card);
      }
      var itemPayload = Object.assign({}, item, {
        quantity: 1,
        item_list_id: listId,
        item_list_name: listName
      });
      if (index >= 0) itemPayload.index = index;
      var dedupeKey = 'select_item:' + listId + ':' + (item.item_id || '') + ':' + index;
      track('select_item', {
        item_list_id: listId,
        item_list_name: listName,
        items: [itemPayload]
      }, dedupeKey);
    } catch (err) {
      debug('select_item failed', err);
    }
  }

  // view_cart — fire once on full cart page load.
  function fireViewCart() {
    var cart = readJson(document.querySelector('script[type="application/json"][data-fbs-ga4-cart]'));
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;
    var dedupeKey = 'view_cart:' + (cart.token || location.pathname) + ':' + cart.items.length + ':' + (cart.value || 0);
    track('view_cart', {
      currency: cart.currency,
      value: cart.value,
      items: cart.items
    }, dedupeKey);
  }

  // remove_from_cart — delegated click on a remove trigger inside an annotated row.
  function onRemoveFromCartClick(event) {
    try {
      var trigger = event.target.closest && event.target.closest('[data-fbs-ga4-remove-trigger]');
      if (!trigger) return;
      var row = trigger.closest('[data-fbs-ga4-line-item]');
      if (!row) return;
      var item = null;
      try { item = JSON.parse(row.getAttribute('data-fbs-ga4-line-item') || 'null'); } catch (_) { return; }
      if (!item) return;
      var currency = row.getAttribute('data-fbs-ga4-currency') || '';
      var price = Number(item.price) || 0;
      var quantity = Number(item.quantity) || 1;
      var dedupeKey = 'remove_from_cart:' + (item.line_key || item.item_variant || item.item_id) + ':' + quantity;
      track('remove_from_cart', {
        currency: currency,
        value: Math.round(price * quantity * 100) / 100,
        items: [{
          item_id: item.item_id,
          item_name: item.item_name,
          item_brand: item.item_brand,
          item_variant: item.item_variant,
          item_category: item.item_category,
          price: price,
          quantity: quantity
        }]
      }, dedupeKey);
    } catch (err) {
      debug('remove_from_cart failed', err);
    }
  }

  function init() {
    try {
      fireViewItemList();
      fireViewCart();
      document.addEventListener('click', onSelectItemClick, true);
      document.addEventListener('click', onRemoveFromCartClick, true);

      // Re-scan for view_item_list when grid re-renders (AJAX filter / pagination / theme editor).
      var rescan = function () { fireViewItemList(); };
      var debounceTimer = null;
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i += 1) {
          var added = mutations[i].addedNodes;
          if (!added || !added.length) continue;
          for (var j = 0; j < added.length; j += 1) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if ((node.matches && node.matches('script[data-fbs-ga4-view-item-list]')) ||
                (node.querySelector && node.querySelector('script[data-fbs-ga4-view-item-list]'))) {
              clearTimeout(debounceTimer);
              debounceTimer = setTimeout(rescan, 150);
              return;
            }
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      document.addEventListener('shopify:section:load', rescan);
    } catch (err) {
      debug('init failed', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
